import { render, staticRenderFns } from "./add-candidates.vue?vue&type=template&id=1440d27a&scoped=true"
import script from "./add-candidates.vue?vue&type=script&lang=ts"
export * from "./add-candidates.vue?vue&type=script&lang=ts"
import style0 from "./add-candidates.vue?vue&type=style&index=0&id=1440d27a&prod&lang=scss&scoped=true"
import style1 from "./add-candidates.vue?vue&type=style&index=1&id=1440d27a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1440d27a",
  null
  
)

export default component.exports